import {DG_axiosNormal} from "../../../custom/axios/normal";

const baseUrl = "https://6257c51fe4e0b73142800162.mockapi.io/phamducdat"
const url = `/dogoo/resource-action-rest/v2.0/resources/byEmployeeId`

export async function getResource() {
    const response = await DG_axiosNormal.get(baseUrl, null);
    return response?.data[0] || []
}


export async function getResourceByEmployeeId(employeeId) {
    const response = await DG_axiosNormal.get(url + "/" + employeeId)
    return response?.data || []
}

export async function updateResourceByEmployeeId(employeeId, params) {
    const response = await DG_axiosNormal.put(url + "/" + employeeId, params)
    return response?.data || []
}
